import { type ProductMaturityHistory } from '@/domain/products/types';
import { getHeader } from '@/features/maturityModel/utils';
import { toDateString } from '@/utils/datetime';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

interface MaturityHistoryItemProps {
  items: ProductMaturityHistory[];
}

const editedTimeStampTemplate = (rowData: ProductMaturityHistory) => toDateString(rowData.editedTimestamp);
const valueTemplate = (rowData: ProductMaturityHistory) => getHeader(rowData.optionValue);

const MaturityHistoryItem = ({ items }: MaturityHistoryItemProps) => {
  return (
    <DataTable value={items} rowGroupMode="rowspan" groupRowsBy="item" sortMode="single" sortField="item" sortOrder={1}>
      <Column field="item" header="Item" sortable />
      <Column field="option" header="Option" sortable />
      <Column field="optionValue" header="Value" body={valueTemplate} sortable />
      <Column field="user" header="User" sortable />
      <Column field="editedTimestamp" header="Edited Timestamp" body={editedTimeStampTemplate} sortable />
    </DataTable>
  );
};

export default MaturityHistoryItem;
